"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiAlertDialogDateRange = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var translationUtils_1 = require("../utils/translationUtils");
exports.KpiAlertDialogDateRange = function (_a) {
    var _b, _c;
    var filter = _a.filter, dateFormat = _a.dateFormat;
    var intl = react_intl_1.useIntl();
    var theme = sdk_ui_theme_provider_1.useTheme();
    var translationData = translationUtils_1.getKpiAlertTranslationData(filter, intl, dateFormat);
    if (!translationData) {
        return null;
    }
    var intlIdRoot = translationData.intlIdRoot, rangeText = translationData.rangeText;
    return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: intlIdRoot, values: {
            calendarIcon: (react_1.default.createElement(sdk_ui_kit_1.Icon.Date, { className: "gd-icon-calendar-kpi", color: (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.complementary) === null || _c === void 0 ? void 0 : _c.c6 })),
            range: react_1.default.createElement("strong", null, rangeText),
        } }));
};
//# sourceMappingURL=KpiAlertDialogDateRange.js.map